import { useCallback, useEffect, useRef } from "react";
function useMouseActions(componentState, updateComponentState, disabled, inputRef) {
  const componentStateRef = useRef(componentState);
  useEffect(() => {
    componentStateRef.current = componentState;
  }, [componentState]);
  const onClick = useCallback(() => {
    if (disabled) return;
    const inputElement = inputRef.current;
    inputElement?.select();
    updateComponentState({ open: true });
  }, [disabled, inputRef, updateComponentState]);
  const onClickAway = useCallback(() => {
    updateComponentState({ open: false });
  }, [updateComponentState]);
  return { onClick, onClickAway };
}
export {
  useMouseActions
};
//# sourceMappingURL=useMouseActions.js.map
